import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export function DirectAuthor({ id = '', name }) {
  return (
    <Link to={`/discover/${id}`} className="hover:underline">
      <span>{name}</span>
    </Link>
  );
}

DirectAuthor.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
};
